import React, { useState } from 'react';

import styled from 'styled-components';

import { NavLink } from 'react-router-dom';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';

import images from '../../constants/images';

const Navbar = () => {
    const [toggleMenu, setToggleMenu] = useState(false);

    return <StyledNav className='navbar drop-shadow'>
        <div className="navbar-logo">
            <img src={images.logo} alt="navbar logo" />
            <h3>Covid Tracker</h3>
        </div>
        <ul className="navbar-links">
            <li><NavLink to="/">Home</NavLink></li>
            <li><a href="https://github.com/kiranhart/covid-tracker" target="_blank" rel="noreferrer" >Code</a></li>
        </ul>
        <div className="navbar-mobile">
            <GiHamburgerMenu fontSize={27} onClick={() => setToggleMenu(true)} />

            {toggleMenu && <div className="navbar-mobile-overlay">
                <IoMdClose fontSize={27} className='overlay-close' onClick={() => setToggleMenu(false)} />

                <ul className="navbar-mobile-links">
                    <li><NavLink to="/">Home</NavLink></li>
                    <li><a href="https://github.com/kiranhart/covid-tracker" target="_blank" rel="noreferrer" >Code</a></li>
                </ul>
            </div>}

        </div>
    </StyledNav>;
};

const StyledNav = styled.nav`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 1.25rem 2rem;
    background: ${({ theme }) => theme.cardBg};
    backdrop-filter: blur(10px);
    position: sticky;
    top: 0;
    z-index: 100;
    border-bottom: 1px solid ${({ theme }) => theme.textSecondary}20;

    .navbar-logo {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 1rem;

        h3 {
            font-size: 1.5rem;
            font-weight: 700;
            background: ${({ theme }) => theme.gradient};
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }
    }

    .navbar-logo img {
        width: 50px;
        height: 50px;
        border-radius: 8px;
    }

    .navbar-links {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        list-style: none;
        gap: 2rem;
    }

    .navbar-links li {
        cursor: pointer;
        
        a {
            font-weight: 500;
            transition: all 0.3s ease;
            padding: 0.5rem 1rem;
            border-radius: 6px;
            
            &:hover {
                background: ${({ theme }) => theme.textSecondary}10;
                color: ${({ theme }) => theme.primary};
            }
            
            &.active {
                color: ${({ theme }) => theme.primary};
                background: ${({ theme }) => theme.primary}15;
            }
        }
    }

    .navbar-mobile {
        display: none;
    }

    .navbar-mobile-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        transition: 0.5s ease;
        flex-direction: column;
        z-index: 5;
        background: ${({ theme }) => theme.cardBg};
        backdrop-filter: blur(10px);
    }

    .overlay-close {
        font-size: 27px;
        cursor: pointer;
        position: absolute;
        top: 20px;
        right: 20px;    
    }

    .navbar-mobile-links{
        text-align: center;
        height: 90%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 2rem;

        li {
            cursor: pointer;
            font-size: 1.25rem;
        }
    }

    @media screen and (max-width: 1150px) {
        .navbar-links {
            display: none;
        }
        
        .navbar-mobile {
            display: flex;
            flex: 1;
            justify-content: flex-end;
            align-items: center;
            list-style: none;
        }
    }

    @media screen and (max-width: 650px) {
        padding: 1rem;

        .navbar-logo img {
            width: 40px;
        }
    }
`;

export default Navbar;
